export default __webpack_public_path__ + "static/media/contact.1d22f0b0.png";